import WarehouseShopOrderItemData, {
    IWarehouseShopOrderItemData
} from "@/http/data/warehouse-shop-order-item-data";

import WarehouseShopOrderNoteData, {
    IWarehouseShopOrderNoteData
} from "@/http/data/warehouse-shop-order-note-data";

export interface IWarehouseShopOrderData {
    id: number;
    number: string;
    building: string;
    remark?: null|string;
    created: string;
    created_by?: string;
    createdBy?: string;
    closed?: null|string;
    loaded?: null|string;
    delivered?: null|string;
    returned?: null|string;
    status: string;
    items?: IWarehouseShopOrderItemData[];
    notes?: IWarehouseShopOrderNoteData[];
}

export default class WarehouseShopOrderData {
    public id: number;
    public number: string;
    public building: string;
    public remark: null|string;
    public created: string;
    public created_by: string;
    public closed: null|string;
    public loaded: null|string;
    public delivered: null|string;
    public returned: null|string;
    public status: string;
    public items: WarehouseShopOrderItemData[];
    public notes: WarehouseShopOrderNoteData[];

    constructor(data: IWarehouseShopOrderData) {
        this.id = Number(data.id);
        this.number = data.number;
        this.building = data.building;
        this.remark = data.remark ?? null;
        this.created = data.created;
        this.created_by = data.created_by ?? data.createdBy ?? "";
        this.closed = data.closed ?? null;
        this.loaded = data.loaded ?? null;
        this.delivered = data.delivered ?? null;
        this.returned = data.returned ?? null;
        this.status = data.status;
        this.items = (data.items ?? []).map(
            item => new WarehouseShopOrderItemData(item)
        );
        this.notes = (data.notes ?? []).map(
            note => new WarehouseShopOrderNoteData(note)
        );
    }
}